var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon1 = function SvgIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#BC5252"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E18989",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.446 11.304a.656.656 0 0 1 1.108 0l.746 1.173a10.5 10.5 0 0 0 3.223 3.223l1.173.746a.656.656 0 0 1 0 1.108l-1.173.746a10.5 10.5 0 0 0-3.223 3.223l-.746 1.173a.656.656 0 0 1-1.108 0l-.746-1.173a10.5 10.5 0 0 0-3.223-3.223l-1.173-.746a.656.656 0 0 1 0-1.108l1.173-.746a10.5 10.5 0 0 0 3.223-3.223z"
  })));
};
export default SvgIcon1;